export default __webpack_public_path__ + "static/media/H0004.bfe91fcd.png";